module.exports = __webpack_public_path__ + "img/seguros.39512d3a.jpg";